import styled from 'styled-components'
import {
  COLOR,
  FONT_SIZE,
  Z_INDEXS,
} from '../../../themes'
const Style = styled.div`
  z-index: ${Z_INDEXS.LV_3};
  width: 433px;
  min-height: 100vh;
  height: 100%;
  background-color: ${COLOR.WHITE};
  box-shadow: -6px 0px 10px ${COLOR.GRAY_5};
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: stretch;
  scroll-behavior: smooth;
  top: 0;
  right: 0;
  animation-timing-function: ease-out;
  transition: transform 200ms ease-in, max-width 0ms ease-in 200ms;
  transform: translateX(433px);
  max-width: 0px;
  overflow-y: scroll;
  &.room-timeline-show {
    max-width: 433px;
    transform: translateX(0px);
    transition: transform 200ms ease-out, max-width 0ms ease-out 0ms;
  }
  .close-btn {
    position: absolute;
    right: 25px;
    top: 25px;
    width: 37px;
    height: 37px;
    padding: 3px;
    box-sizing: border-box;
  }

  .close-btn:hover {
    background: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    border-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1}
  }

  .close-btn:active {
    background: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    border-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1}
  }

  .close-btn:focus {
    background: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    border-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1}
  }

  .room-header {
    display: flex;
    flex-flow: column nowrap;
    margin: 25px 10px 0 10px;
    justify-content: flex-start;
    align-items: stretch;
  }
  .timeline-room-header-container {
    display: flex;
    flex-flow: row nowrap;
    margin: 10px 10px 10px 40px;
    justify-content: center;
    align-items: flex-end;
    font-family: NunitoSansSemiBold;
    font-size: ${FONT_SIZE.XXS}
  }
  .room-name-text {
    line-height: 37px;
    height: 37px;
    align-self: center;
    text-align: center;
    font-weight: bold;
    padding: 0 0;
    margin: 0;
    font-family: NunitoSansSemiBold;
    font-size: ${FONT_SIZE.MD};
  }
  .room-name-subtext {
    line-height: 26px;
    height: 26px;
    align-self: center;
    text-align: center;
    font-weight: bold;
    padding: 0;
    margin: 0 0 0 0;
    font-family: NunitoSansRegular;
    font-size: ${FONT_SIZE.XXS};
  }
  .icon-btn {
    width: 100%;
    height: 100%;
  }
  .timeline-room-month-header {
    flex: 1;
    text-align: right;
    align-items: flex-end;
  }
  .timeline-room-container {
    margin: 0 auto 0 0;
    padding: 0;
  }
  .calendar-week-container {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-end;
    align-items: center;
    -webkit-overflow-scrolling: touch;
    height: 88px;
    min-height: 88px;
    max-height: 88px;
  }
  .calendar-week-container > h4 {
    padding: 0;
    margin: 0;
    font-size: ${FONT_SIZE.LG2};
    font-family: NunitoSansSemiBold;
    color: ${COLOR.GOLD_1};
  }
  .calendar-week-container > p {
    padding: 0;
    margin: 0;
    font-size: ${FONT_SIZE.XXS};
    font-family: NunitoSansSemiBold;
    color: ${COLOR.GOLD_1};
  }
`

export default Style
